import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import svgPaths from "../../../assets/new_ui_imports/Home/svg-tl21z7gm4q.js";
import { imgGroup2 } from "../../../assets/new_ui_imports/Home/svg-q9y98.js";

// ─── Logo ─────────────────────────────────────────────────────────────────────
function GeoLogo({ dark = false }) {
  return (
    <svg width="198" height="39" viewBox="0 0 198 39" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="GeoParking Technologies">
      <g clipPath="url(#clip0_logo)">
        <path d={svgPaths.p1549ab20} fill="#43D651" />
        <path d={svgPaths.p35478f40} fill="#43D651" />
        <path d={svgPaths.p2b031f00} fill="#43D651" />
        <path d={svgPaths.p1d132100} fill="#009BE1" />
        <path d={svgPaths.p17495600} fill="#009BE1" />
        <path d={svgPaths.p1ad7cc80} fill="#009BE1" />
        <path d={svgPaths.p316215f0} fill="#009BE1" />
        <path d={svgPaths.p3349c200} fill="#009BE1" />
        <path d={svgPaths.p28021080} fill="#009BE1" />
        <path d={svgPaths.p3627b690} fill="#009BE1" />
        <path d={svgPaths.p3f6bcd00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pc5e0d20} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p32506200} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p1f2c4b00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p268c0200} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pbd5c880} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p2625ae80} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p38586a00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p25325700} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p89c7ec0} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p3f52da00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pf9d8d00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p22d44300} fill="url(#paint0_logo)" />
        <path d={svgPaths.p81ad600} fill="#F46FF0" />
        <path d={svgPaths.p81ad600} fill="url(#paint1_logo)" />
        <path d={svgPaths.p7c13680} fill="url(#paint2_logo)" />
        <path d={svgPaths.p2f9b4eb0} fill="url(#paint3_logo)" />
        <path d={svgPaths.p7051cc0} fill="white" />
        <path d={svgPaths.p2a7001f0} fill="white" />
        <path d={svgPaths.pd3fd400} fill="white" />
        <path d={svgPaths.p5de4a00} fill="white" />
        <path d={svgPaths.p1adebf00} fill="url(#paint4_logo)" />
        <path d={svgPaths.p1f12b500} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p1d1fb600} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p3a326d80} fill={dark ? "white" : "#565656"} />
      </g>
      <defs>
        <linearGradient id="paint0_logo" x1="19.39" x2="19.39" y1="0" y2="37.54" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9DBACF" /><stop offset="0.25" stopColor="white" /><stop offset="0.52" stopColor="#B3CBD7" />
          <stop offset="0.71" stopColor="#5A6585" /><stop offset="0.85" stopColor="#B3C4D4" /><stop offset="1" stopColor="#466C81" />
        </linearGradient>
        <linearGradient id="paint1_logo" x1="37.38" x2="1.46" y1="19.51" y2="19.51" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </linearGradient>
        <linearGradient id="paint2_logo" x1="19.03" x2="19.61" y1="43.13" y2="5.51" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </linearGradient>
        <radialGradient id="paint3_logo" cx="0" cy="0" r="1" gradientTransform="translate(19.68 24.29) scale(11.77 11.77)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </radialGradient>
        <linearGradient id="paint4_logo" x1="19.39" x2="19.39" y1="22.27" y2="3.52" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" stopOpacity="0" /><stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_logo"><rect width="198" height="39" fill="white" /></clipPath>
      </defs>
    </svg>
  );
}

function useBasePath() {
  const location = useLocation();
  if (location.pathname.startsWith("/newDasboard")) return "/newDasboard";
  if (location.pathname.startsWith("/newDashboard")) return "/newDashboard";
  if (location.pathname.startsWith("/new")) return "/new";
  return "/newDashboard";
}

// ─── Header ───────────────────────────────────────────────────────────────────
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [mobileCompanyOpen, setMobileCompanyOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const basePath = useBasePath();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setCompanyOpen(false); }, [location.pathname]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setCompanyOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const simpleLinks = [
    { label: "Home",       to: `${basePath}/home` },
    { label: "Solutions",  to: `${basePath}/solutions` },
    { label: "Technology", to: `${basePath}/technology` },
  ];

  const companyLinks = [
    { label: "Contact Us",          to: `${basePath}/contact` },
    { label: "Investor Relations",  to: `${basePath}/company` },
  ];

  const isActive = (to) => {
    if (to.endsWith("/home")) {
      return (
        location.pathname === basePath ||
        location.pathname === `${basePath}/` ||
        location.pathname.toLowerCase() === `${basePath}/home`.toLowerCase()
      );
    }
    return location.pathname.startsWith(to);
  };

  const isCompanyActive = companyLinks.some(({ to }) => location.pathname.startsWith(to));

  const navLinkClass = (active) =>
    `font-['Google_Sans_Flex',sans-serif] text-[16px] leading-tight transition-colors ${active ? "text-[#0a66c2] font-semibold" : "text-[#3f3f3f] hover:text-[#0a66c2]"}`;

  return (
    <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.08)]" : "bg-white shadow-[0_4px_10px_rgba(0,0,0,0.08)]"}`}>
      <div className="max-w-[1400px] mx-auto px-6 h-20 flex items-center justify-between">
        <NavLink to={`${basePath}/home`} className="flex-shrink-0">
          <GeoLogo />
        </NavLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {simpleLinks.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              className={navLinkClass(isActive(to))}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
            >
              {label}
            </NavLink>
          ))}

          {/* Company dropdown */}
          <div ref={dropdownRef} className="relative">
            <button
              onClick={() => setCompanyOpen((o) => !o)}
              className={`flex items-center gap-[4px] font-['Google_Sans_Flex',sans-serif] text-[16px] leading-tight transition-colors ${isCompanyActive ? "text-[#0a66c2] font-semibold" : "text-[#3f3f3f] hover:text-[#0a66c2]"}`}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
              aria-haspopup="true"
              aria-expanded={companyOpen}
            >
              Company
              <svg className={`w-4 h-4 transition-transform duration-200 ${companyOpen ? "rotate-180" : ""}`} fill="none" viewBox="0 0 16 16">
                <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            {/* Dropdown panel */}
            <div className={`absolute top-[calc(100%+12px)] right-0 bg-white rounded-[8px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-gray-100 min-w-[180px] overflow-hidden transition-all duration-200 ${companyOpen ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-2 pointer-events-none"}`}>
              {companyLinks.map(({ label, to }) => (
                <NavLink
                  key={label}
                  to={to}
                  className={`block px-[18px] py-[12px] font-['Google_Sans_Flex',sans-serif] text-[15px] transition-colors whitespace-nowrap ${isActive(to) ? "text-[#0a66c2] bg-[#f0f7ff] font-semibold" : "text-[#3f3f3f] hover:bg-[#f5f5f5] hover:text-[#0a66c2]"}`}
                  style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
                >
                  {label}
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink to="/login" className="bg-[#0a66c2] text-white font-['Lato:Medium',sans-serif] text-[16px] px-5 py-2 rounded-[5px] hover:bg-[#0856a8] transition-colors">
            Login
          </NavLink>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-[#3f3f3f] transition-transform duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-[#3f3f3f] transition-opacity duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-[#3f3f3f] transition-transform duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${menuOpen ? "max-h-[400px]" : "max-h-0"}`}>
        <nav className="px-6 py-4 flex flex-col gap-4">
          {simpleLinks.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              className={`font-['Google_Sans_Flex',sans-serif] text-[16px] ${isActive(to) ? "text-[#0a66c2] font-semibold" : "text-[#3f3f3f]"}`}
            >
              {label}
            </NavLink>
          ))}

          {/* Mobile Company submenu */}
          <div>
            <button
              onClick={() => setMobileCompanyOpen((o) => !o)}
              className={`flex items-center gap-[4px] font-['Google_Sans_Flex',sans-serif] text-[16px] w-full text-left ${isCompanyActive ? "text-[#0a66c2] font-semibold" : "text-[#3f3f3f]"}`}
            >
              Company
              <svg className={`w-4 h-4 transition-transform duration-200 ${mobileCompanyOpen ? "rotate-180" : ""}`} fill="none" viewBox="0 0 16 16">
                <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div className={`overflow-hidden transition-all duration-200 ${mobileCompanyOpen ? "max-h-24 mt-2" : "max-h-0"}`}>
              {companyLinks.map(({ label, to }) => (
                <NavLink
                  key={label}
                  to={to}
                  className={`block pl-4 py-2 font-['Google_Sans_Flex',sans-serif] text-[15px] ${isActive(to) ? "text-[#0a66c2] font-semibold" : "text-[#6b6b6b]"}`}
                >
                  {label}
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink to="/login" className="bg-[#0a66c2] text-white font-['Lato:Medium',sans-serif] text-[16px] px-5 py-2 rounded-[5px] w-fit">
            Login
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

// ─── Footer ───────────────────────────────────────────────────────────────────
export function Footer() {
  const basePath = useBasePath();

  const socialLinks = [
    {
      label: "LinkedIn",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d={svgPaths.p347f9100} fill="white" />
        </svg>
      ),
    },
    {
      label: "Facebook",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d={svgPaths.pb8cc300} fill="white" />
        </svg>
      ),
    },
    {
      label: "Instagram",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d={svgPaths.p25a7dc00} fill="white" />
        </svg>
      ),
    },
    {
      label: "Twitter / X",
      icon: (
        <div className="overflow-clip size-6 relative">
          <div
            className="absolute inset-0 mask-alpha mask-intersect mask-no-clip mask-no-repeat"
            style={{
              maskImage: `url("${imgGroup2}")`,
              maskPosition: "0px -1.125px",
              maskSize: "24px 24px",
            }}
          >
            <svg className="absolute block inset-0 size-full" fill="none" viewBox="0 0 24 21.75">
              <path d={svgPaths.p3e3ab00} fill="white" />
            </svg>
          </div>
        </div>
      ),
    },
    {
      label: "YouTube",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d={svgPaths.p9733b30} fill="white" />
        </svg>
      ),
    },
  ];

  return (
    <footer className="bg-[#0d1117] border-t-[3px] border-[#0a66c2] relative">
      <div className="max-w-[1400px] mx-auto px-6 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-2 flex flex-col gap-8">
            <div><GeoLogo dark /></div>
            <div>
              <h4 className="font-['Montserrat:Bold',sans-serif] font-bold text-white text-[2rem] leading-[1.3] mb-3">
                {"Powering the Future of "}
                <br />
                Autonomous Parking
              </h4>
              <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
                GeoParking connects property owners with Robotaxi operators through an AI-powered platform that simplifies parking management, maximizes efficiency, and unlocks new revenue opportunities.
              </p>
            </div>
            <div className="flex items-center gap-4">
              {socialLinks.map((s) => (
                <a key={s.label} href="#" aria-label={s.label} className="opacity-80 hover:opacity-100 transition-opacity shrink-0 inline-flex items-center justify-center">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h5 className="font-['Inter:Semi_Bold',sans-serif] font-semibold text-white text-[1rem] mb-6">Explore</h5>
            <ul className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] space-y-4">
              {[
                { label: "Home",                to: `${basePath}/home` },
                { label: "Solutions",           to: `${basePath}/solutions` },
                { label: "Technology",          to: `${basePath}/technology` },
                { label: "Investor Relations",  to: `${basePath}/company` },
              ].map(({ label, to }) => (
                <li key={label}>
                  <NavLink
                    to={to}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="hover:text-white transition-colors"
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-['Inter:Semi_Bold',sans-serif] font-semibold text-white text-[1rem] mb-6">Resources</h5>
            <ul className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] space-y-4">
              {[
                { label: "Privacy Policy",                              to: "/privacy-policy" },
                { label: "Website Terms of Use",                        to: "/terms-of-use" },
                { label: "Parking Lot Management Terms of Service",     to: "/terms-of-service" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <NavLink
                    to={to}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="hover:text-white transition-colors"
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-[#2c3a4e] mt-10 pt-6 flex flex-col md:flex-row justify-between gap-2">
          <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
            © 2026 GeoParking Technologies, Inc. All rights reserved.
          </p>
          <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
            Driving smarter mobility — one parking space at a time.
          </p>
        </div>
      </div>
    </footer>
  );
}

// ─── Scroll to top ────────────────────────────────────────────────────────────
export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className={`fixed bottom-8 right-8 z-50 size-14 rounded-full bg-[#0a66c2] shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-[#0856a8] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 19V5M5 12l7-7 7 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
